import { Select } from '@chakra-ui/react';
import { projectStage } from '../../../utils/layoutConfig';

function setProjectStage({ e, projectInfo, setProjectInfo }) {
	const value = e.target.value;
	const newProjectInfo = { ...projectInfo };
	newProjectInfo.stage = value;
	setProjectInfo(newProjectInfo);
}

const CreateSaveProjectStage = ({ projectInfo, setProjectInfo }) => {
	return (
		<Select
			defaultValue={projectInfo.stage ? projectInfo.stage : ''}
			onChange={(e) => setProjectStage({ e, projectInfo, setProjectInfo })}
			size="sm"
			h={8}
		>
			{projectStage &&
				projectStage.map((ps, index) => (
					<option key={index} value={ps.value}>
						{ps.name}
					</option>
				))}
		</Select>
	);
};

export default CreateSaveProjectStage;
